import {
  DisplayFormErrors,
  EfsMelcoEfsModelsEfsDefaultAppSetting,
  SelectField,
  SwitchField,
  VerticalForm,
} from "melco-shared-logic";
import { useTranslation } from "react-i18next";

type DisplayBasicSettingsFormProps = {
  defaultSettings: EfsMelcoEfsModelsEfsDefaultAppSetting;
};

export const DisplayBasicSettingsForm: React.FC<
  DisplayBasicSettingsFormProps
> = ({ defaultSettings }) => {
  const { t } = useTranslation();

  const printDefaultOptions = (defaultSettings.output_format_list?.list ?? [])
    .filter((option) => option.extension && option.service_type === "PRINT")
    .map((option) => ({
      label: option.extension!,
      value: option.extension!,
    }));

  const embroideryDefaultOptions = (
    defaultSettings.output_format_list?.list ?? []
  )
    .filter(
      (option) => option.extension && option.service_type === "EMBROIDERY"
    )
    .map((option) => ({
      label: option.extension!,
      value: option.extension!,
    }));

  return (
    <VerticalForm>
      <DisplayFormErrors />

      <SelectField
        name="measurement_unit"
        label={t("settings.basic.form.label.measurement_unit")}
        options={(defaultSettings.measurements ?? []).map((measurement) => {
          return {
            label: t([
              `settings.basic.form.values.measurement_unit.${measurement.key}` as any,
              measurement.display_text!,
            ]),
            value: measurement.key!,
          };
        })}
        showSearch
        optionFilterProp="label"
      />

      <SelectField
        mode="multiple"
        showSearch
        optionFilterProp="label"
        filterOption
        name="embroidery_output_format"
        label={
          t("settings.basic.form.label.embroidery_output_format") || undefined //TODO: i18n
        }
        style={{ width: "100%" }}
        options={embroideryDefaultOptions}
      />
      <SelectField
        mode="multiple"
        name="print_output_format"
        allowClear
        label={
          t("settings.basic.form.label.print_output_format") || undefined //TODO: i18n
        }
        style={{ width: "100%" }}
        options={printDefaultOptions}
        showSearch
        optionFilterProp="label"
        filterOption
      />
      <SwitchField
        name={"enable_folder_grouping"}
        label={t("settings.basic.form.label.folder_name_rules") || undefined}
      />
      <SwitchField
        name={"enable_debug"}
        label={t("settings.basic.form.label.detailed_debugging") || undefined}
      />
    </VerticalForm>
  );
};
